import styled from 'styled-components';

export const Container = styled.div`
  table {
    font-size: 12px;

    thead tr,
    thead tr > th {
      background-color: #eaecef;
      position: -webkit-sticky;
      position: -moz-sticky;
      position: -ms-sticky;
      position: -o-sticky;
      position: sticky;
      top: 0;
      vertical-align: middle;
    }

    td {
      color: #707070;
    }

    tbody:not(.tbody-modal) tr:hover {
      cursor: pointer;
      color: #007bff;
      text-decoration: underline;

      td {
        color: #007bff;
      }
    }

    &.table-orgaos-publicos,
    &.table-concorrentes,
    &.table-produtos-e-servicos {
      thead tr th:nth-child(3),
      tbody tr td:nth-child(3) {
        text-align: center !important;
      }
    }

    &.table-orgaos-publicos,
    &.table-concorrentes {
      thead tr th:nth-child(2),
      tbody tr td:nth-child(2) {
        text-align: center !important;
      }
    }

    &.table-resultados {
      thead tr th:nth-child(4),
      tbody tr td:nth-child(4) {
        text-align: center !important;
      }
    }
  }
`;
